import {css, tokens} from '@sail/ui';
import {media} from '@sail/engine';

export const styles = {
  link: css({
    font: 'body.medium',
    [media.up(tokens.viewport.medium)]: {
      font: 'body.large',
    },
  }),
};
